import React, {useCallback} from 'react';
import {
	// Checkbox,
	Table,
} from '@phonectas/unifon-ui-kit';
import {DATE_FORMATS, getDateByCustomFormat} from 'utils/date';
import useThreeSixtyNewStore from 'common/stores/threeSixtyStore';
import {shallow} from 'zustand/shallow';
import {Invoice} from 'common/types/store/threeSixtyTypes';

interface VismaInvoiceTableRowProps {
	data: Invoice;
	onClick: (item: Invoice) => void;
	index: number;
	activeRow?: number | null;
	// batchChecked: string[];
	// setBatchChecked: (value: string) => void;
}

const VismaInviceTableRow: React.FC<VismaInvoiceTableRowProps> = ({
	data,
	onClick,
	index,
	activeRow,
	// batchChecked,
	// setBatchChecked,
}) => {
	const {getVismaInvoice} = useThreeSixtyNewStore((state) => ({getVismaInvoice: state.getVismaInvoice}), shallow);
	const onRowClick = useCallback(() => {
		onClick(data);
		getVismaInvoice(data?.client_no, data?.invoice_number);
	}, [data, getVismaInvoice, onClick]);

	return (
		<Table.Row
			onClick={onRowClick}
			style={{padding: '0'}}
			selected={index === activeRow}
			index={index}
			key={index}
		>
			{/* <Table.Cell
				onClick={e => e.stopPropagation()}
			>
				<Checkbox
					checked={batchChecked.includes(String(data?.invoice_number))}
					onChange={() => setBatchChecked(String(data?.invoice_number))}
				/>
			</Table.Cell> */}
			<Table.Cell>{data?.billing_group}</Table.Cell>
			<Table.Cell>{data?.invoice_number}</Table.Cell>
			<Table.Cell>{data?.calculated_status.toLowerCase()}</Table.Cell>
			<Table.Cell>{getDateByCustomFormat(data?.due_date, DATE_FORMATS.DD_MM_YY)}</Table.Cell>
			<Table.Cell>{`${data?.currency_balance_item},-`}</Table.Cell>
			<Table.Cell>{data?.debt_coll_case_no}</Table.Cell>
			<Table.Cell>{data?.reminder_step}</Table.Cell>
			<Table.Cell>{data?.transaction_text}</Table.Cell>
			<Table.Cell>{data?.client_no}</Table.Cell>
		</Table.Row>
	);
}

export default VismaInviceTableRow;
